import React from "react";
import "./AirportInformation.css"
import CustomTable from "../CustomTable"
import { useState, useEffect } from 'react';

function AirportInformation({AirportSelection}) {


    const [AirportInfo,setAirportInfo] = useState([])


    
    

      useEffect(() => {
        const str = JSON.stringify(AirportSelection[0]);
        const code = str.slice(-4,-1)

        console.log("code", code)

        var url = "/api/airport_info/" + code;
    
        fetch(url).then((res) =>
           res.json().then((res) => {

            setAirportInfo(res.data)
    
            console.log("Airport info", res.data)


          })
        )
        .catch((error) => {
          console.log("Refetching data for airport info!")
        });
      }, [AirportSelection]);




        if(AirportInfo.length !== 0){


            //Fix General info data for tables
            let keys = Object.keys(AirportInfo["general data"]["Άλλα γενικά στοιχεία"])

            let table1_data = []

            table1_data.push({[keys[0]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[0]], [keys[1]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[1]], [keys[2]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[2]]})
            
            let table2_data = []

            table2_data.push({[keys[3]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[3]], [keys[4]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[4]], [keys[5]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[5]]})
            
            let table3_data = []

            table3_data.push({[keys[6]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[6]], [keys[7]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[7]], 
            [keys[8]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[8]], [keys[9]] : AirportInfo["general data"]["Άλλα γενικά στοιχεία"][keys[9]]})
            
            
            //Fix Accecibility data for tables

            let access_data = []
            access_data.push(AirportInfo["general data"]["Προσβασιμότητα"])
            

            //Specifications data
            let maneuverElements_data = []
            maneuverElements_data.push(AirportInfo["technical data"]["Στοιχεία Πεδίου Ελιγμών"])
            

            let airport_details = []
            airport_details.push(AirportInfo["technical data"]["Στοιχεία Αεροσταθμού"])
           
            
           
        return(
                <div style = {{marginBottom: "30%"}}>
                    <div className="container filters-wrapper" style = {{marginTop: "5%"}}>
                        {/* TODO -> DOWNLOAD BUTTON */}
                        <div style = {{display: "flex", marginTop: "3%"}}>
                            <div>
                                <p>Αποτελέσματα για :</p>
                                <h5>{AirportInfo["basic info"].About["Επίσημη Ονομασία Αεροδρομίου"]}</h5>
                            </div>
                            <div style = {{marginLeft: "25%"}}>
                                <p>Κωδικός Αναφοράς Αεροδρομίου ΙΑΤΑ</p>
                                {/* TODO -> ΝΑ ΓΙΝΕΙ DYNAMIC*/}
                                <p style = {{marginLeft: "85%"}}><strong> {AirportInfo["basic info"].About["Κωδικός Aναφοράς Aεροδρομίου ΙΑΤΑ"]}</strong></p>
                            </div>
                        </div>
                        <div style = {{display: "flex"}}>
                            <p style = {{marginRight: "5%"}}><strong>Ιστοσελίδα: </strong></p>
                            {/* TODO -> ΝΑ ΓΙΝΕΙ ANCHOR TAG + DYNAMIC */}
                            <a href={AirportInfo["basic info"].About["Ιστοσελίδα"]}>{AirportInfo["basic info"].About["Επίσημη Ονομασία Αεροδρομίου"]}</a>

                        </div>
                        {/* TODO -> KATI EIKONES+ NA FYGEI TO MARGIN APO PANV */}
                    </div>

                    <h5 style = {{marginTop: ""}}>Γενικά χαρακτηριστικά</h5>
                    <hr style = {{borderColor: "#b3e6ff"}}></hr>
                    <p><strong>Άλλα γενικά στοιχεία</strong></p>
                    <CustomTable data = {table1_data}></CustomTable>
                    <CustomTable data = {table2_data}></CustomTable>
                    <CustomTable data = {table3_data}></CustomTable>


                    <hr style = {{borderColor: "#b3e6ff", marginTop: "10%"}}></hr>
                    <p><strong>Προσβασιμότητα</strong></p>
                    <CustomTable data = {access_data}></CustomTable>


                    <h5 style = {{marginTop: "10%"}}>Τεχνικά χαρακτηριστικά</h5>
                    <hr style = {{borderColor: "#b3e6ff"}}></hr>
                    <p><strong>Διάδρομοι</strong></p>
                    <CustomTable data = {AirportInfo["technical data"]["Διάδρομοι"]}></CustomTable>

                    <hr style = {{borderColor: "#b3e6ff", marginTop: "10%"}}></hr>
                    <p><strong>Στοιχεία Πεδίου Ελιγμών</strong></p>
                    <CustomTable data = {maneuverElements_data}></CustomTable>



                    <hr style = {{borderColor: "#b3e6ff", marginTop: "10%"}}></hr>
                    <p><strong>Στοιχεία Αεροσταθμού</strong></p>
                    <CustomTable data = {airport_details}></CustomTable>







                </div>
                    
        );
        }
        else {
            return <></>
        }
}

export default AirportInformation;
